import React from 'react';
// import React from 'react';
import './ClickableItem.scss';

const ClickableItem = (props) => {

    const handleOnClick = () =>{
        props.onClick(props.index, props.text)
    }
    return (
        <>
            <a className="clickable-item" onClick={handleOnClick}>
                {/* <span>{props.text}</span> */}
            </a>
        </>
    );

};

export default ClickableItem; 